export default __webpack_public_path__ + "facda13.png";